import { Button, Modal, ModalProps } from "antd";
import { VinculoDeNovoResponsavelForm } from "./VinculoDeNovoResponsavelForm";
import { TypeAluno } from "../../../../../Models/Domain/Pessoa/Aluno";
import { cloneElement, ReactNode, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";

export interface IVinculoNovoResponsavelModalProps extends ModalProps {
    aluno:TypeAluno;
    buttonOpen?:ReactNode;
    onOpen?:() => void;
    onClose?:() => void;
    onSucess?:() => void;
}
export default function VinculoNovoResponsavelModal({
    aluno,
    buttonOpen,
    onOpen,
    onCancel,
    onOk,
    onSucess,
    onClose,
    ...rest
}:IVinculoNovoResponsavelModalProps) {
    const [ open, setOpen ] = useState(false);
    function abrirModal() {
        setOpen(true);
        onOpen?.();
    }

    function fecharModal(e?:React.MouseEvent<HTMLButtonElement>) {
        setOpen(false);
    }

    return <>
        {
            buttonOpen 
            && cloneElement(buttonOpen as React.ReactElement<any>, { onClick : abrirModal }) 
            || <Button type="dashed"  size="middle" style={{ width : "100%" }} icon={<PlusOutlined />} onClick={abrirModal}>Adicionar responsável</Button>
        }
        <Modal
            {...rest}
            title={"Vincular novo responsável"}
            destroyOnClose={true}
            onCancel={(e) => {
                fecharModal();
                onCancel?.(e);
            }}
            open={open}
            footer={<></>}
        >
            <VinculoDeNovoResponsavelForm 
                aluno={aluno!}
                onSucesso={() => {
                    fecharModal();
                    onSucess?.();
                }}
                onCancelar={() => {
                    fecharModal();
                    onClose?.();
                }}
            />
        </Modal>
    </>
}